var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArchwaySolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 6 L 3 12 L 5 12 L 5 24 L 3 24 L 3 26 L 5 26 L 13 26 L 13 24 L 13 19 C 13 17.346 14.346 16 16 16 C 17.654 16 19 17.346 19 19 L 19 24 L 19 26 L 27 26 L 29 26 L 29 24 L 27 24 L 27 12 L 29 12 L 29 6 L 3 6 z M 5 8 L 27 8 L 27 10 L 5 10 L 5 8 z M 7 12 L 25 12 L 25 24 L 21 24 L 21 19 C 21 16.243 18.757 14 16 14 C 13.243 14 11 16.243 11 19 L 11 24 L 7 24 L 7 12 z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArchwaySolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/archway-solid.c12969d3e8dfd87300b5ba30b60795c7.svg";